import React, { useEffect } from "react";
import ActiveImage from "../components/ActiveImage";

const ActiveImagePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ActiveImage />
    </>
  );
};

export default ActiveImagePage;
